var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canShowNewsletter
    ? _c("rb-modal", {
        attrs: {
          show: _vm.getModalStatus,
          "handle-close": _vm.closeModal,
          "modal-class": "rb-newsletter-modal",
          "modal-class-container": "rb-newsletter-modal",
          "modal-wrapper-class": "header",
          "modal-class-theme": "rb-modal-container--dark",
          "focus-enabled": true,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "modal-content",
              fn: function () {
                return [
                  _c("rb-newsletter-modal-content", {
                    attrs: {
                      "set-needs-reload-status": _vm.setNeedsReloadStatus,
                    },
                    on: {
                      closeNewsletterModal: function ($event) {
                        return _vm.onCloseNewsletterModal()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content-left",
                          fn: function () {
                            return [_vm._t("content-left")]
                          },
                          proxy: true,
                        },
                        {
                          key: "content-right",
                          fn: function () {
                            return [_vm._t("content-right")]
                          },
                          proxy: true,
                        },
                        {
                          key: "success",
                          fn: function () {
                            return [_vm._t("success")]
                          },
                          proxy: true,
                        },
                        {
                          key: "disclaimer",
                          fn: function () {
                            return [_vm._t("disclaimer")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          436082247
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }